module.exports = __webpack_public_path__ + "static/img/票@3x.834aa81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/供应链金融/票@3x.png
// module id = i75D
// module chunks = 192